import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterBonusReport from 'views/partner/reports/bonusReport/filterBonusReport'; // Importing filter component for bonus report
import TableBonusReport from 'views/partner/reports/bonusReport/tableBonusReport'; // Importing table component for bonus report
import DetailsBonusReport from 'views/partner/reports/bonusReport/detailsBonusReport'; // Importing details component for bonus report
import RecordBonusReport from 'views/partner/reports/bonusReport/recordBonusReport'; // Importing record component for bonus report
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the Bonus Report View.
 * @extends JetView
 */
export default class BonusReportView extends JetView {
    /**
     * Configures the layout of the Bonus Report View.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const right = {
            // Right side layout configuration
            type: 'wide',
            rows: [
                PlayersView, // Players view component
                RecordBonusReport, // Record bonus report component
                DetailsBonusReport, // Details bonus report component
            ],
        };
        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: 10000000, // Maximum number of items for pagination
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export dropdown
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            if (value == 1) {
                                // Excel export
                                var table = $$('treetable'); // Reference to the table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Bonos'),
                                    ignore: { detailTittle: true }, // Ignore detail title in export
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    webix.toPDF($$('treetable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Bonos'),
                                        autowidth: true, // Automatically adjust width
                                        ignore: { detailTittle: true }, // Ignore detail title in export
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };
        const left = {
            // Left side layout configuration
            css: 'int-left',
            rows: [
                FilterBonusReport, // Filter component for bonus report
                { id: 'res2', view: 'resizer' }, // Resizer for layout adjustment
                TableBonusReport, // Table component for bonus report
                toolbar, // Toolbar component
            ],
        };
        const avanc = {
            // Advanced details accordion configuration
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [
                { id: 'dColl', header: _('Detalles Avanzados'), body: right }, // Advanced details section
            ],
        };
        const avancResp = {
            // Responsive advanced details accordion configuration
            view: 'accordion',
            multi: true,
            collapsed: true,
            rows: [
                {
                    id: 'dColl',
                    header: _('Detalles Avanzados'),
                    body: right,
                    minWidth: 200,
                    on: {
                        onItemClick: function () {
                            // Event handler for item click
                            var height;
                            $(function () {
                                height =
                                    $('.scrolling > .webix_scroll_cont').height() -
                                    $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                if (!$$('dColl').config.collapsed) {
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)', // Adjust scroll position
                                    });
                                } else {
                                    height =
                                        $('.scrolling > .webix_scroll_cont').height() -
                                        $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)', // Adjust scroll position
                                    });
                                }
                            });
                        },
                    },
                },
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            // Return the main layout configuration
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            css: 'scrolling',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        left, // Left side layout
                        { id: 'res', view: 'resizer' }, // Resizer for layout adjustment
                        document.body.offsetWidth < 500 ? avancResp : avanc, // Responsive advanced details
                    ],
                },
            ],
        };
    }
    /**
     * Initializes the Bonus Report View.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Execute when Webix is ready
            if (screen.width < 500) {
                // Check screen width for responsive design
                $$('res').hide(); // Hide resizer for small screens
                $$('res2').hide(); // Hide second resizer for small screens
            }
            $.fn.scrollBottom = function () {
                // jQuery function to get scroll bottom position
                return $(document).height() - this.scrollTop() - this.height();
            };
        });
    }
}

// FILE DOCUMENTED
